/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commissions_SubtitleInputs */



/**
* | output |
* | --- |
* | "Review affiliate commission entries, approve closed months, and mark payouts." |
*
* @param {Partner_Admin_Commissions_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commissions_subtitle = /** @type {((inputs?: Partner_Admin_Commissions_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commissions_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Affiliate-Provisionen prüfen, abgeschlossene Monate freigeben und Auszahlungen markieren.")
	return /** @type {LocalizedString} */ ("Review affiliate commission entries, approve closed months, and mark payouts.")
});